import * as React from "react";
import IndexHeader from "app/shared-components/IndexHeader";
import CustomButton from "app/shared-components/CustomColorButton";

import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import history from "@history";
import YouthOpportunitiesFilter from "./components/YouthOpportunitiesFilter";
import YouthOpportunitiesCard from "./components/YouthOpportunitiesCard";

export default function YouthOpportunitiesViewPage() {
  const jobData = [
    {
      _id: "1",
      title: "Front Desk Assistant",
      company: "Codice",
      category: "Administrative Support",
      hourlyRate: "$14/hr",
      address: "Washington",
      mileage: 80,
      startDate: "7/6/2025",
      isActive: true,
      endDate: "8/20/2025",
      description:
        "• Greet visitors and direct them to the appropriate department or staff\n• Answer phone calls and take messages professionally\n• Maintain sign-in sheets and front desk logs\n• Assist with filing, scanning, and basic data entry\n• Help distribute incoming mail and packages\n• Ensure front desk area remains tidy and welcoming",
    },
    {
      _id: "2",
      title: "Events Assistant",
      company: "Codice",
      category: "Community Programs",
      hourlyRate: "$16/hr",
      address: "Washington",
      mileage: 80,
      startDate: "7/6/2023",
      isActive: true,
      endDate: "8/20/2023",
      description:
        "• Support the setup and supervision of recreational events and activities\n• Assist employees in organized games, arts, or wellness programs\n• Help staff maintain safe and inclusive program spaces\n• Distribute equipment and ensure proper usage\n• Assist in monitoring attendance and behavior",
    },
    {
      _id: "3",
      title: "Clerical Assistant",
      company: "Codice",
      category: "Office Administration",
      hourlyRate: "$15/hr",
      address: "Washington",
      mileage: 90,
      startDate: "7/6/2023",
      isActive: true,
      endDate: "8/20/2023",
      description:
        "• Perform basic data entry and update spreadsheets\n• Organize and file physical or digital documents\n• Assist with scheduling appointments or meetings\n• Prepare office supplies and inventory sheets\n• Support staff with light research or printing tasks\n• Maintain confidentiality when handling sensitive documents",
    },
  ];

  return (
    <>
      <IndexHeader name={"Job Opportunities"} update={false} add={false} />
      <YouthOpportunitiesFilter />
      <YouthOpportunitiesCard jobData={jobData} />
    </>
  );
}
